module.exports = __webpack_public_path__ + "static/media/JP_RC_EYELASHES02.313346e5.jpg";